import React from 'react'
import { useTranslation } from 'react-i18next'

import Select from '../../../packages/kiti/components/form/Select'

const PrioritySelect = props => {
  const { t } = useTranslation('serviceOrders')
  const OPTIONS = [
    { name: t('priority.critical'), id: 1 },
    { name: t('priority.high'), id: 2 },
    { name: t('priority.medium'), id: 3 },
    { name: t('priority.low'), id: 4 }
  ]

  return <Select options={OPTIONS} {...props} />
}

export default PrioritySelect
